module.exports = __webpack_public_path__ + "img/layanan-kesehatan.08dceca6.webp";